import React, {
  useState,
} from 'react';
import { withRouter } from 'react-router-dom';
/* STYLE */
import {
  Grid,
  Form,
  Button,
  Menu,
} from 'semantic-ui-react';
/* TRANSLATIONS */
import {
  translate,
} from 'react-multi-lang';
/* LOGIC */
import useChangeMyPassword from '../../logic/users/useChangeMyPassword';
import useLawPracticeAccountInfo from '../../logic/users/useLawPracticeAccountInfo';

import ResponsiveContainer from '../../components/containers/ResponsiveContainer';
import PageHeader from '../../components/headers/PageHeader';
import useScrollTopOnMount from '../../logic/ui/useScrollTopOnMount';
import bgName from '../../img/bg/membership-bg.jpg';

const LawPracticeAccountPage = ({
  history,
  t,
}) => {
  const [activeForm, setActiveForm] = useState('info');
  useScrollTopOnMount();
  const {
    currentPwd,
    setCurrentPwd,
    newPwd,
    setNewPwd,
    newPwdConfirm,
    setNewPwdConfirm,
    isLoading,
    isDisabled,
    changeMyPwd,
  } = useChangeMyPassword();
  const {
    name,
    setName,
    surname,
    setSurname,
    position,
    setPosition,
    address,
    setAddress,
    city,
    setCity,
    zipCode,
    setZipCode,
    country,
    setCountry,
    corporateName,
    setCorporateName,
    isDisabled: isDisabledMyInfo,
    isLoading: isLoadingMyInfo,
    updateMyInfo,
  } = useLawPracticeAccountInfo();
  return (
    <ResponsiveContainer
      minHeight={300}
      bgName={bgName}
      header={
        <PageHeader
          header="myAccount"
        />
      }
    >
      <Grid textAlign="center" verticalAlign="middle"  className="padded">
        <Grid.Row>
          <Menu pointing secondary size="huge">
            <Menu.Item
              name="info"
              content={t('myInfo')}
              color="red"
              active={activeForm === 'info'}
              onClick={() => setActiveForm('info')}
            />
            <Menu.Item
              name="pwd"
              content={t('myPwd')}
              color="red"
              active={activeForm === 'pwd'}
              onClick={() => setActiveForm('pwd')}
            />
          </Menu>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column className="max-width-45em">
            {activeForm === 'pwd'
              ? (
                <Form size="big" loading={isLoading}>
                  <Form.Input
                    fluid
                    icon="lock"
                    value={currentPwd}
                    onChange={(e, { value }) => setCurrentPwd(`${value}`)}
                    iconPosition="left"
                    placeholder={t('currentPwd')}
                    type="password"
                  />
                  <Form.Input
                    fluid
                    icon="lock"
                    value={newPwd}
                    onChange={(e, { value }) => setNewPwd(`${value}`)}
                    iconPosition="left"
                    placeholder={t('newPwd')}
                    type="password"
                  />
                  <Form.Input
                    fluid
                    icon="lock"
                    value={newPwdConfirm}
                    onChange={(e, { value }) => setNewPwdConfirm(`${value}`)}
                    iconPosition="left"
                    placeholder={t('newPwdConfirm')}
                    type="password"
                  />
                  <Button color="red" fluid size="big" disabled={isDisabled} onClick={() => changeMyPwd()}>
                    {t('changeMyPwd')}
                  </Button>
                </Form>
              ) : (
                <Form size="big" loading={isLoadingMyInfo}>
                  <Form.Input
                    fluid
                    icon="user"
                    value={surname}
                    onChange={(e, { value }) => setSurname(`${value}`)}
                    iconPosition="left"
                    placeholder={t('surname')}
                  />
                  <Form.Input
                    fluid
                    icon="user"
                    value={name}
                    onChange={(e, { value }) => setName(`${value}`)}
                    iconPosition="left"
                    placeholder={t('name')}
                  />
                  <Form.Input
                    fluid
                    icon="warehouse"
                    value={corporateName}
                    onChange={(e, { value }) => setCorporateName(`${value}`)}
                    iconPosition="left"
                    placeholder={t('corporateName')}
                  />
                  <Form.Input
                    fluid
                    icon="certificate"
                    value={position}
                    onChange={(e, { value }) => setPosition(`${value}`)}
                    iconPosition="left"
                    placeholder={t('position')}
                  />
                  <Form.Input
                    fluid
                    icon="map"
                    value={address}
                    onChange={(e, { value }) => setAddress(`${value}`)}
                    iconPosition="left"
                    placeholder={t('address')}
                  />
                  <Form.Input
                    fluid
                    icon="map"
                    value={city}
                    onChange={(e, { value }) => setCity(`${value}`)}
                    iconPosition="left"
                    placeholder={t('city')}
                  />
                  <Form.Input
                    fluid
                    icon="map"
                    value={zipCode}
                    onChange={(e, { value }) => setZipCode(`${value}`)}
                    iconPosition="left"
                    placeholder={t('zipCode')}
                  />
                  <Form.Input
                    fluid
                    icon="map"
                    value={country}
                    onChange={(e, { value }) => setCountry(`${value}`)}
                    iconPosition="left"
                    placeholder={t('country')}
                  />
                  <Button color="red" fluid size="big" disabled={isDisabledMyInfo} onClick={() => updateMyInfo()}>
                    {t('update')}
                  </Button>
                </Form>
              )
            }
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </ResponsiveContainer>
  );
};

export default withRouter(translate(LawPracticeAccountPage));
